import React from 'react';

import { Box, Icon, Text } from '@betterment/samba-react';

const NoNewItems: React.FC<React.PropsWithChildren<{ variant?: boolean }>> = ({ variant = false }) => {
  return (
    <Box>
      <Box css={{ display: 'flex', justifyContent: 'center', mb: 'space.50' }}>
        {variant ? (
          <Icon mode="decorative" name="Glitter" color="icon.weakest" size="small" />
        ) : (
          <Icon mode="decorative" name="Sun" color="icon.weakest" size="small" />
        )}
      </Box>
      <Box css={{ display: 'flex', justifyContent: 'center' }}>
        <Text color={variant ? 'text' : 'text.placeholder'}>Nothing to see here. Have a great day!</Text>
      </Box>
    </Box>
  );
};

export default NoNewItems;
